// Source of truth for the version badge shown in the site header.
// Rewritten by scripts/release.mjs on every release.
export const SITE_VERSION = 'v0.1.4'
